import { Checkbox } from '@react_components/basic_toolkit';
import React, { Component } from 'react';
import * as Styles from './Styles';

type Props = {
	checked: boolean;
	onClick: () => void;
	label: string;
	required: boolean;
};

type State = {};

class ConsentItem extends Component<Props, State> {
	state = {};

	render() {
		return (
			<Styles.ItemContainer>
				<Checkbox
					checked={this.props.checked}
					onChange={() => this.props.onClick()}
					label={
						<>
							<span
								dangerouslySetInnerHTML={{
									__html: this.props.label,
								}}
							/>
							<Styles.Reqstart>
								{this.props.required && '* '}
							</Styles.Reqstart>
						</>
					}
				/>
			</Styles.ItemContainer>
		);
	}
}

export default ConsentItem;
